<template>
  <OneCol
    :center="true"
    :borderRadius="0"
    :backgroundImage="$store.state.width > 767 ? $store.state.copy.donateAsk.image : $store.state.copy.donateAsk.imageMob"
    padding="0px"
    maxWidth="100%"
    backgroundColor="#000000"
    extraClass="smaller"
  >
    <template v-slot:title>
      <div class="fit_wrap center">
        <h1>{{ $store.state.copy.donateAsk.title }}</h1>
      </div>
    </template>
    <template v-slot:body>
      <div class="donate_wrap">
        <div class="donate_text" v-html="$store.state.copy.donateAsk.copy">
        </div>
        <div class="button_wrap" style="margin-bottom: 15px;">
          <GenericButton
            @click="gotoPage($store.state.copy.donateAsk.donate_link), analytics('donate', 'clicked'), gotoSlide('shareAsk'), $store.commit('updateExtraProgress')"
            :text="$store.state.copy.donateAsk.yes_btn"
            textColor="white"
            minWidth="220px"
          ></GenericButton>
          <GenericButton
            @click="gotoSlide('shareAsk'), $store.commit('updateExtraProgress')"
            :text="$store.state.copy.donateAsk.no_btn"
            textColor="white"
            minWidth="220px"
            color="#4A4A4A"
            hoverColor="#686868"
          ></GenericButton>
        </div>
      </div>
    </template>
  </OneCol>
</template>

<script>
import OneCol from "../components/template/OneCol";
import GenericButton from "../components/generic/GenericButton";
export default {
  name: "Donate",
  components: {
    OneCol,
    GenericButton
  },
  methods: {
    gotoPage(url) {
      var queryString = window.location.search;
      if (url.indexOf('?') !== -1) {
        queryString = queryString.replace('?', '&');
      }
      url += queryString;
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.donate_wrap {
  background: black;
  padding-bottom: 40px;
  @media (max-width: 767px) {
    padding: 12px;
  }
}
.donate_text {
  max-width: 640px;
  margin: 0 auto;
  color: white;
  font-size: 28px;
  padding: 40px 30px 20px;
  font-family: "AmnestyTradeGothic";
  @media (max-width: 767px) {
    padding: 0;
    font-size: 24px;
  }
}
</style>